import { memo } from 'react';
import Image from 'next/image';
import styles from '@components/ProductCardNew/ProductImage/PackshotImageHover/PackshotImageHover.styles';
import { packshotSizes } from '@components/ProductCardNew/const';
import getImageQuality from '@utils/getImageQuality';
type PropsType = {
  url: string;
  alt: string;
  isOpened?: boolean;
  isSmall?: boolean;
  isSlider?: boolean;
};
const PackshotImageHover = memo(({
  url,
  alt,
  isOpened = false,
  isSmall = false,
  isSlider = false
}: PropsType) => {
  if (!url || url === '') return null;
  return <Image alt={alt} src={url} fill sx={styles.hoverImage(isOpened, isSmall, isSlider)} quality={getImageQuality()} sizes={packshotSizes} className="hoverImage" />;
});
PackshotImageHover.displayName = 'PackshotImageHover';
export default PackshotImageHover;